import type { Block, ComposerDocument } from '../types';
import { makeBlock } from '../state/tree';
import { makeNewDocument } from '../state/store';

export interface TemplateDef {
  id: string;
  name: string;
  description: string;
  theme: string;
  build: () => Block[];
}

export const TEMPLATES: TemplateDef[] = [
  {
    id: 'blank',
    name: 'Blank Page',
    description: 'Just the paper. Add what you want.',
    theme: '',
    build: () => [],
  },

  {
    id: 'worksheet',
    name: 'Practice Worksheet',
    description: 'Header, directions, MCQ, fill-in-the-blank, work area.',
    theme: '',
    build: () => [
      makeBlock('doc-header', { props: {
        brand: 'Classroom.', kicker: 'Worksheet',
        metaLine1: 'Mathematics · Grade 5',
        metaLine2: 'Unit 3 · Worksheet 3.4',
      }}),
      makeBlock('eyebrow', { props: { text: 'Operations & Problem Solving' } }),
      makeBlock('hero', { props: { title: 'Numbers, Operations & Word Problems', stampValue: '20' } }),
      makeBlock('name-bar'),
      makeBlock('directions'),
      makeBlock('section-heading', { props: { letter: 'A', title: 'Multiple Choice', points: '4 pts' } }),
      makeBlock('choice-list'),
      makeBlock('section-heading', { props: { letter: 'B', title: 'Fill in the Blank', points: '3 pts' } }),
      makeBlock('question-list'),
      makeBlock('section-heading', { props: { letter: 'C', title: 'Show Your Work', points: '6 pts' } }),
      makeBlock('work-area'),
    ],
  },

  {
    id: 'rubric',
    name: 'Assessment Rubric',
    description: '4-point analytic rubric with weighted criteria.',
    theme: '',
    build: () => [
      makeBlock('doc-header', { props: { kicker: 'Rubric', metaLine1: '/ 100', metaLine2: '' } }),
      makeBlock('eyebrow', { props: { text: 'Assessment' } }),
      makeBlock('hero', { props: { title: 'Project Rubric', showStamp: false } }),
      makeBlock('rubric'),
    ],
  },

  {
    id: 'lesson',
    name: 'Lesson Plan',
    description: 'Single-page daily plan with timed agenda.',
    theme: '',
    build: () => [
      makeBlock('doc-header', { props: { kicker: 'Lesson Plan', metaLine1: '45 min', metaLine2: '' } }),
      makeBlock('eyebrow', { props: { text: 'Daily plan' } }),
      makeBlock('hero', { props: { title: 'Photosynthesis intro', showStamp: false } }),
      makeBlock('paragraph', { props: { html: '<p><strong>Objective:</strong> SWBAT explain how plants convert light into stored energy.</p>' } }),
      makeBlock('agenda'),
    ],
  },

  {
    id: 'flashcards',
    name: 'Flashcards',
    description: 'Two-by-two grid of vocabulary cards.',
    theme: '',
    build: () => [
      makeBlock('doc-header', { props: { kicker: 'Flashcards', metaLine1: 'Cut along marks', metaLine2: '' } }),
      makeBlock('eyebrow', { props: { text: 'Vocabulary' } }),
      makeBlock('card-grid'),
    ],
  },

  {
    id: 'bingo',
    name: 'Vocabulary Bingo',
    description: 'Single 5×5 bingo card.',
    theme: '',
    build: () => [
      makeBlock('doc-header', { props: { kicker: 'Bingo', metaLine1: 'Math vocabulary', metaLine2: '' } }),
      makeBlock('eyebrow', { props: { text: 'Game · 5x5' } }),
      makeBlock('bingo-grid'),
    ],
  },
];

export function newDocumentFromTemplate(t: TemplateDef): ComposerDocument {
  return makeNewDocument({
    name: t.name,
    theme: t.theme,
    tree: t.build(),
  });
}
